/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offer_Tab_PacksInputs */

const en_offer_tab_packs = /** @type {(inputs: Offer_Tab_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packs and plans`)
};

const pl_offer_tab_packs = /** @type {(inputs: Offer_Tab_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karnety i plany`)
};

/**
* | output |
* | --- |
* | "Packs and plans" |
*
* @param {Offer_Tab_PacksInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offer_tab_packs = /** @type {((inputs?: Offer_Tab_PacksInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offer_Tab_PacksInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offer_tab_packs(inputs)
	return en_offer_tab_packs(inputs)
});